import classnames from 'classnames';
import React from 'react';
import Icon from '../icon';
const LeftArea = (props) => {
    const { children, style, className } = props;
    let a_children = React.Children.toArray(children);
    let c_children = a_children.slice(a_children.length - 2);
    return (<a className={classnames('bs-pull-left bs-bar-nav-btn', className)} style={style}>
      {c_children}
    </a>);
};
const RightArea = (props) => {
    const { children, style, className } = props;
    let a_children = React.Children.toArray(children);
    // console.log(a_children)
    let c_children = a_children.slice(a_children.length - 2);
    return (<a className={classnames('bs-pull-right bs-bar-nav-btn', className)} style={style}>
      {c_children}
    </a>);
};
export class TitleArea extends React.Component {
    constructor() {
        super(...arguments);
        this.handleItemClick = (e) => {
            e.preventDefault();
            this.props.onClick && this.props.onClick(this.props, e);
        };
    }
    render() {
        const { children, style, className } = this.props;
        return (<div className={classnames('bs-bar-title', className)} onClick={this.handleItemClick} style={style}>
        {children}
      </div>);
    }
}
export class Item extends React.Component {
    constructor() {
        super(...arguments);
        this.handleItemClick = (e) => {
            e.preventDefault();
            this.props.onClick && this.props.onClick(this.props, e);
        };
    }
    render() {
        const { prefixCls, style, icon, iconStyle, text } = this.props;
        return (<a className={prefixCls} style={style} onClick={this.handleItemClick}>
        {Icon && <Icon type={icon} style={iconStyle}/>}
        <span className='bs-bar-item-label'>{text}</span>
      </a>);
    }
}
Item.defaultProps = {
    prefixCls: 'bs-bar-item',
};
export default class Header extends React.Component {
    constructor() {
        super(...arguments);
        this.onHandleTitleClick = (e) => {
            e.preventDefault();
            console.log(this.props.title);
            this.props.onTitleClick && this.props.onTitleClick({
                text: this.props.title,
            }, e);
        };
    }
    render() {
        const { className, style, fixStatus, title, 
        //onTitleClick = noop,
        prefixCls = 'bs-bar', } = this.props;
        return (<div onClick={this.onHandleTitleClick} className={classnames(`${prefixCls} ${prefixCls}-nav`, { [`${prefixCls}-nav-fixstatus`]: fixStatus }, className)} style={style}>
        {title ? title : this.props.children}
      </div>);
    }
}
Header.Item = Item;
Header.LeftArea = LeftArea;
Header.TitleArea = TitleArea;
Header.RightArea = RightArea;



// WEBPACK FOOTER //
// ./components/header/index.tsx